import * as React from "react";
import type { SVGProps } from "react";
const SvgJetTime = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#034ea1"
      d="m46.5 9.181-1.286 5.556h-5.905l-3.098 15.03a9 9 0 0 0-.175.847 4 4 0 0 0-.059.555q0 .82.263 1.258.264.439.673.673t.906.262q.482.03.965.03a25 25 0 0 0 2.981-.176l-1.403 6.375q-1.287.116-2.573.204t-2.63.088q-1.463 0-2.894-.263a7.8 7.8 0 0 1-2.573-.936 4.96 4.96 0 0 1-1.811-1.842q-.674-1.17-.615-3.04 0-.585.117-1.317a30 30 0 0 1 .293-1.55l3.39-16.198H25.63l1.286-5.556h5.32L34.106 0h8.302l-1.87 9.181z"
    />
    <path
      fill="#ffa000"
      d="M18.875 0 11.04 37.778q-.175.585-.35 1.491a10 10 0 0 1-.527 1.784 5.3 5.3 0 0 1-.876 1.49q-.528.615-1.404.615a38 38 0 0 1-2.981-.117L3.5 49.708q1.01.06 2.017.175Q6.54 50 7.533 50q2.807 0 4.678-.585t3.156-1.754q1.287-1.17 2.047-2.983t1.286-4.21L27.177 0z"
    />
  </svg>
);
export default SvgJetTime;
